<template>
  <div class="labels background-opacity">
    <HeaderGeneral banner="pers-labels.jpg"/>
    
    <img src="../../assets/airdutemps.png" class="airdutemps"/>
    <img src="../../assets/paris-75.png" class="paris-75"/>
    
    <div id="nav" class="li-lvl2">
      <Nav :links="links" title="Labels, innovations et services" :visible="visible"/>
    </div>
        
  </div>
  
</template>

<style lang="scss" scoped>
    .airdutemps {
      position: absolute;
      z-index: 2;
      width: 168px;
      height: auto;
      right: 121px;
      bottom: 387px;
      @media (min-width: 992px) {
        right: 118px;
        bottom: 261px;
      }
    }
    .paris-75 {
      position: absolute;
      z-index: 2;
      width: 81px;
      height: auto;
      right: 30px;
      bottom: 398px;
      @media (min-width: 992px) {
        right: 27px;
        bottom: 272px;
      }
    }
    
</style>

<script>
import HeaderGeneral from '@/components/Header.vue'
import Nav from '@/components/Nav.vue'
// @ is an alias to /src

export default {
  name: 'Labels',
  components: {
    HeaderGeneral,
    Nav,
  },
  data: () => {
      
        return { 
            links: [
                {
                    title: "Labels et <br />Eco-responsabilité",
                    path: 'EcoResponsabilite',
                    icon: 'labels.svg'
                },
                {
                    title: "Innovations et Services pour mieux vivre",
                    path: 'InnovationsServices',
                    icon: 'innovations-mieux-vivre.svg'
                },
            ],
            imageList: [
                { title: 'img 1', url: require('../../assets/pers-home.jpg') },
                { title: 'img 1', url: require('../../assets/pers-home.jpg') }
            ],
            index: null,
            visible: true
        };
    },
  
}
</script>